module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/44fd91d9e3ac6b6f10840bff8441e08e.png";